import React from 'react';
import './css/CardNotification.css';
import { MdCheckCircle, MdError } from 'react-icons/md'; // Importando ícones

const CardNotification = ({ message, type, onClose }) => {
    return (
        <div className={`notification-card ${type}`}>
            <div className="notification-content">
                {type === 'success' ? (
                    <MdCheckCircle className="icon success-icon" />
                ) : (
                    <MdError className="icon error-icon" />
                )}
                <p>{message}</p>
            </div>
            <button className="close-button" onClick={onClose}>×</button>
            <div className="progress-bar">
                <div className="progress"></div>
            </div>
        </div>
    );
};

export default CardNotification;
